exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".guest-confirm-popup .msg-block .row{margin-top:15px}.guest-confirm-popup .msg-block .reg-error{color:#d35853;border-style:solid;border-width:1px 0;margin:20px 0 10px;padding:10px 0;text-align:center;display:none}.guest-confirm-popup .msg-block .reg-error.show{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/stylus/_guest-purchase-popup.styl
// module id = 574
// module chunks = 4